/* eslint-disable camelcase */
export const FIXED_CATEGORIES = {
	cs: [
		{
			title: "Tipy na výlet",
			poiTypeId: 1001,
			fixed: true,
		}, {
			title: "Restaurace",
			poiTypeId: 5322,
			fixed: true,
		}, {
			title: "Ubytování",
			poiTypeId: 5521,
			fixed: true,
		}, {
			title: "Bankomat",
			poiTypeId: 5311,
			fixed: true,
		}, {
			title: "Zastávky/MHD",
			poiTypeId: 6001,
			fixed: true,
		}, {
			title: "Zábavní parky",
			poiTypeId: 1261,
			fixed: true,
		}, {
			title: "Dětské hřiště",
			poiTypeId: 1134,
			fixed: true,
		}, {
			title: "Lékárny",
			poiTypeId: 5611,
			fixed: true,
		}, {
			title: "Čerpací stanice",
			poiTypeId: 5313,
			fixed: true,
		}, {
			title: "Supermarket",
			poiTypeId: 5628,
			fixed: true,
		}, {
			title: "Sportoviště",
			poiTypeId: 5418,
			fixed: true,
		}, {
			title: "Parkoviště",
			poiTypeId: 1052,
			fixed: true,
		}, {
			title: "Kino",
			poiTypeId: 5214,
			fixed: true,
		}, {
			title: "Divadlo",
			poiTypeId: 5211,
			fixed: true,
		}, {
			title: "Nemocnice",
			poiTypeId: 5613,
			fixed: true,
		}, {
			title: "Policie",
			poiTypeId: 5112,
			fixed: true,
		},
	],
	en: [
		{
			title: "Travel tips",
			poiTypeId: 1001,
			fixed: true,
		}, {
			title: "Restaurants",
			poiTypeId: 5322,
			fixed: true,
		}, {
			title: "Accommodation",
			poiTypeId: 5521,
			fixed: true,
		}, {
			title: "ATM",
			poiTypeId: 5311,
			fixed: true,
		}, {
			title: "Public transport",
			poiTypeId: 6001,
			fixed: true,
		}, {
			title: "Amusement parks",
			poiTypeId: 1261,
			fixed: true,
		}, {
			title: "Playground",
			poiTypeId: 1134,
			fixed: true,
		}, {
			title: "Pharmacy",
			poiTypeId: 5611,
			fixed: true,
		}, {
			title: "Petrol station",
			poiTypeId: 5313,
			fixed: true,
		}, {
			title: "Supermarket",
			poiTypeId: 5628,
			fixed: true,
		}, {
			title: "Sports ground",
			poiTypeId: 5418,
			fixed: true,
		}, {
			title: "Parking area",
			poiTypeId: 1052,
			fixed: true,
		}, {
			title: "Cinema",
			poiTypeId: 5214,
			fixed: true,
		}, {
			title: "Theatre",
			poiTypeId: 5211,
			fixed: true,
		}, {
			title: "Hospital",
			poiTypeId: 5613,
			fixed: true,
		}, {
			title: "Police station",
			poiTypeId: 5112,
			fixed: true,
		},
	],
};
